import React from 'react';
import SearchBar from '../components/SearchBar';
import { usePageMeta, SITE_NAME } from '../lib/usePageMeta';

const NotFoundPage = () => {
  usePageMeta(`Page not found | ${SITE_NAME}`);

  return (
    <div className="wrap pt-12 md:pt-16">
      <div className="max-w-2xl">
        <h1 className="font-serif text-4xl font-semibold md:text-5xl">There’s no page at this address</h1>
        <p className="mt-4 text-lg text-ink-soft">
          The link may be old or mistyped. If you came here for a word, search for it below.
        </p>
        <SearchBar variant="field" className="mt-8" />
      </div>
    </div>
  );
};

export default NotFoundPage;
